import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import { useTheme } from 'styled-components';
const UnknownTile = ({ type, component }) => {
    const { isDev } = usePlatform();
    const theme = useTheme();
    if (!isDev)
        return null;
    return (_jsxs("div", { style: {
            padding: theme.spacing.md,
            border: '1px dashed #ccc',
            margin: `${theme.spacing.md} 0`,
        }, children: [_jsxs("strong", { children: ["Unknown Tile Type: ", type] }), _jsxs("details", { style: { marginTop: theme.spacing.md }, children: [_jsx("summary", { children: "Component Data" }), _jsx("pre", { style: { fontSize: theme.fonts.body3, overflow: 'auto' }, children: JSON.stringify(component, null, 2) })] })] }));
};
export default UnknownTile;
